import { useCallback, useEffect, useMemo, useState } from 'react';
import { Outlet } from 'react-router-dom';

import { getNoticesOptions } from '../../../../api/theHive/redeProto';
import { NoticeOption } from '../../../../api/theHive/redeProto/types';
import useErrorMessage from '../../../../hooks/useErrorMessage';
import useSnackbar from '../../../../hooks/useSnackbar';
import { NoticeSelector } from './components/NoticeSelector';
import { SubNav } from './components/SubNav';
import { RedeProtoOutletContext } from './types';

export function RedeProto(): JSX.Element {
  const [selectedNoticeId, setSelectedNoticeId] = useState<number | null>(null);
  const [noticeOptions, setNoticeOptions] = useState<NoticeOption[]>([]);

  const { handleSnackbar } = useSnackbar();
  const { getErrorMessage } = useErrorMessage();

  const loadOptions = useCallback(async () => {
    try {
      const response = await getNoticesOptions();
      if (response.detail.description) {
        throw new Error(response.detail.description);
      }
      if (response.data) {
        setNoticeOptions(response.data);
      }
    } catch (error) {
      handleSnackbar(getErrorMessage(error), true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    loadOptions();
  }, [loadOptions]);

  const context = useMemo<RedeProtoOutletContext>(
    () => ({ selectedNoticeId, setSelectedNoticeId, noticeOptions }),
    [selectedNoticeId, noticeOptions]
  );

  return (
    <div>
      <SubNav />
      <NoticeSelector
        selectedNoticeId={selectedNoticeId}
        setSelectedNoticeId={setSelectedNoticeId}
        noticeOptions={noticeOptions}
      />
      <Outlet context={context} />
    </div>
  );
}
